import { Box, getVariant } from '@apia/theme';
import { IAttachment } from '../ChatController';
import { observer } from 'mobx-react-lite';
import { FileAttachment } from './FileAttachment';

const Attachments = observer(
  ({
    attachments,
    onRemove,
    onAddDescription,
  }: {
    attachments: IAttachment[];
    onRemove?: (a: IAttachment) => unknown;
    onAddDescription?: (a: IAttachment, d: string) => unknown;
  }) => {
    if (!attachments.length) return null;

    return (
      <Box
        className="attachments"
        {...getVariant('layout.common.newChat.attachments')}
      >
        {attachments.map((x) => (
          <FileAttachment
            attachment={x}
            onRemove={onRemove ? () => onRemove(x) : undefined}
            onAddDescription={onAddDescription}
            key={x.id}
          />
        ))}
      </Box>
    );
  },
);
export default Attachments;
